var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M4.6 10.1H11V11.1H4.6z",
    transform: "rotate(-65.285 7.834 10.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36404d",
    d: "M6.5,13C6.4,13,6.6,13,6.5,13C6.2,13,6,13.2,6,13.5S6.2,14,6.5,14c0.1,0-0.1,0,0,0 C6.8,14,7,13.8,7,13.5S6.8,13,6.5,13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M10.7 7.4H11.7V13.8H10.7z",
    transform: "rotate(-24.697 11.166 10.6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#36404d",
    d: "M12.5,13C12.6,13,12.4,13,12.5,13c0.3,0,0.5,0.2,0.5,0.5S12.8,14,12.5,14c-0.1,0,0.1,0,0,0 c-0.3,0-0.5-0.2-0.5-0.5S12.2,13,12.5,13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#66798f",
    d: "M9 0H10V13H9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.5 1.5H14.5V10.5H3.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M14,2v8H4V2H14 M15,1H3v10h12V1L15,1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1ebf2",
    d: "M2 1H16V2H2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M16 1L2 1 2 2 16 2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1ebf2",
    d: "M4 2L6 2 6 1 3 1 3 10.8 4 10.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M3 0.5A1.5 1.5 0 1 0 3 3.5A1.5 1.5 0 1 0 3 0.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M3,1c0.6,0,1,0.4,1,1S3.6,3,3,3S2,2.6,2,2S2.4,1,3,1 M3,0C1.9,0,1,0.9,1,2s0.9,2,2,2s2-0.9,2-2 S4.1,0,3,0L3,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M1.5,15.5v-4.6l-1-0.3V6c0-0.8,0.7-1.5,1.5-1.5h5.5c0.6,0,1,0.4,1,1s-0.4,1-1,1H4.4l-0.8,9H1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M7.5,5C7.8,5,8,5.2,8,5.5S7.8,6,7.5,6H4.8H3.9L3.8,6.9L3.1,15H2v-3.8v-0.8l-0.8-0.2L1,10.2V6 c0-0.6,0.4-1,1-1h2H7.5 M7.5,4H4H2C0.9,4,0,4.9,0,6v5l1,0.3V16h3l0.8-9h2.7C8.3,7,9,6.3,9,5.5S8.3,4,7.5,4L7.5,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenOff);
export default __webpack_public_path__ + "static/media/screen--off.aa682a81b7abaad1090a51c69ce24ce2.svg";
export { ForwardRef as ReactComponent };